import React, { useEffect, useState } from 'react'
import { useWeatherStore } from '../stores/weatherStore'
import { useUserStore } from '../stores/userStore'

import WEATHERCODE_MAP from '../lib/weathercodeMap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DAY_MAP = new Map([
    [0, 'Sun'],
    [1, 'Mon'],
    [2, 'Tue'],
    [3, 'Wed'],
    [4, 'Thu'],
    [5, 'Fri'],
    [6, 'Sat'],
])

export default function CardWeather( { columns } ) { 
    const editMode = useUserStore( state => state.editMode )
    const checkWeather = useWeatherStore(state => state.checkWeather)
    const dailyForecast = useWeatherStore(state => state.dailyForecast)
    const currentWeather = useWeatherStore(state => state.currentWeather)

    const display = useWeatherStore(state => state.display)
    const weatherColumns = useWeatherStore(state => state.columns)

    useEffect(() => {
        checkWeather()
    }, [checkWeather])
    
    if(!currentWeather || !currentWeather.temperature) return (<WeatherError columns={columns} />);
    if(!dailyForecast || dailyForecast.length === 0) return (<WeatherError columns={columns} />);

    const { temperature, weathercode } = currentWeather

    const displayCurrent = display === 'forecast' ? false : true;
    const displayForecast = display === 'current' ? false : true;

    return (
        <li key="weather" className="card-item weather" style={{'--weather-cols' : weatherColumns === 'auto' ? columns : weatherColumns }}>
            {currentWeather && dailyForecast && displayCurrent
                ? <CurrentWeatherBlock temperature={temperature} weathercode={weathercode} temperatureMax={dailyForecast[0].temperatureMax} temperatureMin={dailyForecast[0].temperatureMin} /> 
                : !displayCurrent ? '' : 'Waiting on current weather.'
            }
            {editMode ? '' : dailyForecast && displayForecast ? <ForecastWeatherBlock forecast={dailyForecast} /> : displayForecast ? 'Waiting on forecast' : ''}
            {editMode ? <WeatherSettings /> : ''}
        </li>
    )
}

function WeatherSettings() {
    const { lat, lon } = useWeatherStore(state => state.location)
    const setLocation = useWeatherStore(state => state.setLocation)
    const handleWeatherAPI = useWeatherStore(state => state.handleWeatherAPI)
    const [latitude, setLatitude] = useState(lat)
    const [longitude, setLongitude] = useState(lon)
    const [disable, setDisable] = useState(false);

    const weatherColumns = useWeatherStore(state => state.columns)
    const display = useWeatherStore(state => state.display)
    const setWeatherColumns = useWeatherStore(state => state.setColumns)
    const setDisplay = useWeatherStore(state => state.setDisplay)

    
    const handleLocationUpdate = () => {
        setLocation({lat: latitude, lon: longitude})
        handleWeatherAPI();
        setDisable(true);
        setTimeout(() => {
            setDisable(false);
        }, 1500)
    }

    return(
        <div className="weather-options">
            <div>
                <div>
                    <span>Latitude</span>
                    <label className="card-input-group">
                        <FontAwesomeIcon icon="location-arrow" />
                        <input type="text" value={latitude} onChange={ (e) => { setLatitude(e.target.value) } } />
                    </label>
                </div>
                <div>
                    <span>Longitude</span>
                    <label className="card-input-group">
                        <FontAwesomeIcon icon="location-arrow" />
                        <input type="text" value={longitude} onChange={ (e) => { setLongitude(e.target.value) } }  />
                    </label>
                </div>
            </div>
            <div>
                <div>
                    <span>Columns</span>
                    <label className="card-select-group">
                        <select className="select" value={weatherColumns} onChange={ e => setWeatherColumns(e.target.value)}>
                            <option value="auto">Auto</option> 
                            <option value="1">1 Columns</option> 
                            <option value="2">2 Columns</option> 
                            <option value="3">3 Columns</option> 
                            <option value="4">4 Columns</option> 
                            <option value="5">5 Columns</option> 
                            <option value="6">6 Columns</option> 
                        </select>
                    </label>
                </div>
                <div>
                    <span>Display</span>
                    <label className="card-select-group">
                        <select className="select" value={display} onChange={ e => setDisplay(e.target.value)}>
                            <option value="full">Full</option> 
                            <option value="current">Current</option> 
                            <option value="forecast">Forecast</option>   
                        </select>
                    </label>
                </div>
            </div>
            <button className={`save-weather ${disable ? 'disabled' : ''}`} onClick={handleLocationUpdate}><FontAwesomeIcon icon='check' /> {disable ? 'Saving' : 'Save Weather'}</button>
        </div>
    )
}

function WeatherError({columns}) {
    return(
        <li key="weather" className="card-item weather" style={{'--weather-cols' : columns }}>
            <p>Error in retriving the weather... Sozza</p>
        </li>
    )
}

function CurrentWeatherBlock({temperature, weathercode, temperatureMin, temperatureMax}) {
    const weather = WEATHERCODE_MAP.get(weathercode)

    return (
        <div className='current-weather-block'>
            <div className="feature">
                <FontAwesomeIcon icon={weather.icon} />
                <span className="temperature">{Math.round(temperature)}<Deg /></span>
            </div>
            <span className="weather-name">{weather.name}</span>
            <div className="temperature-min-max">
                <span className="temperature-min-max max"><FontAwesomeIcon icon='chevron-up' />{Math.round(temperatureMax)}<Deg /></span>
                <span className="temperature-min-max min"><FontAwesomeIcon icon='chevron-down' />{Math.round(temperatureMin)}<Deg /></span> 
            </div>
        </div>
    )
}

function ForecastWeatherBlock({forecast}) {
  return (
    <div className="daily-forecast">
        {forecast.map( (item, index) => {
            if(index === 0) return false;

            return (
                <ForecastWeatherItem data={item} key={index} />
            )
        })}
    </div>
  )
}

function ForecastWeatherItem({data}) {
    const weather = WEATHERCODE_MAP.get(data.weatherCode)
    const date = new Date(data.day);

    const dayName = DAY_MAP.get(date.getDay())

    return(
        <div className="forecast-item">
            <FontAwesomeIcon icon={weather.icon} />
            <div className="temperature-min-max item-group">
                <span className="temperature-min-max max">{data.temperatureMax ? Math.round(data.temperatureMax) : '20.1' }<Deg /></span>
                <span className="temperature-min-max min">{Math.round(data.temperatureMin)}<Deg /></span>
            </div>
            <div className="item-group">
                <div className="weather-name">{weather.name}</div>
                <div className="day">{dayName}</div>
            </div>
        </div>
    )
}

function Deg({unit = 'C'}) {
    return (
        <span className="temp-unit">{ unit === 'C' ? '°' : `°${unit}`}</span>
    )
}